{
  "header": {
    "filters": {
      "brand": "Brand",
      "collection": "Season / collection",
      "label": "Filters",
      "productType": "Category"
    },
    "search": {
      "label": "Search",
      "placeholder": "Search for a product name or reference"
    }
  },
  "productCard": {
    "productType": "Category:",
    "reference": "Reference:"
  }
}
